// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__2OIot","savePackageButton":"ClientWallet_savePackageButton__3iTa7"};